import { render, staticRenderFns } from "./ResourceQuickAlign.vue?vue&type=template&id=c447d9e6"
import script from "./ResourceQuickAlign.vue?vue&type=script&lang=js"
export * from "./ResourceQuickAlign.vue?vue&type=script&lang=js"
import style0 from "./ResourceQuickAlign.vue?vue&type=style&index=0&id=c447d9e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports